// extracted by mini-css-extract-plugin
module.exports = {"list":"list-ZG85DoQA","bold":"bold-34mrq3DL"};